import { format, parseISO } from 'date-fns';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('dateFormat', (dateString, formatString = 'dd/MM/yyyy') => {
    return format(parseISO(dateString), formatString);
  });
});
